const careers = [
  { id: 1, text: '大学・大学院卒' },
  { id: 2, text: '大学中退' },
  { id: 6, text: '短大・高専卒' },
  { id: 7, text: '専門卒' },
  { id: 3, text: '高卒' },
  { id: 4, text: '高校中退' },
  { id: 5, text: '中卒' },
  { id: 8, text: '学生(中学・高校在学中)' },
  { id: 9, text: '学生（その他在学中）' }
]

export default {
  data: function () {
    return {
      careers
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CareerMixin.js